import { setShowValuationModal } from '../State/showValuationModal';

export default () => async (dispatch) => {
  dispatch(setShowValuationModal(false));
}